import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {environment} from '../../../../../../../environments/environment';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {StatesService} from '../../../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../../../../shared/services/authentication/authentication.service';
import {ProjectAlarmsUserAddListComponent} from '../project-alarms-user-add-list/project-alarms-user-add-list.component';
import {Subscription} from 'rxjs';
import {ModalService} from '../../../../../../shared/services/modal/modal.service';
import {AlarmsTypes} from '../../../../../../shared/types/alarms.types';
import AlarmUser = AlarmsTypes.AlarmUser;
import AlarmValidator = AlarmsTypes.AlarmValidator;

@Component({
    selector: 'app-project-alarms-user-remove-list',
    templateUrl: './project-alarms-user-remove-list.component.html',
    styleUrls: ['./project-alarms-user-remove-list.component.css']
})
export class ProjectAlarmsUserRemoveListComponent implements OnInit, OnDestroy {
    public displayedColumns: string[];
    public alarmUsers: MatTableDataSource<AlarmUser | AlarmValidator>;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;
    public showSpinner = false;
    public faPlus = faPlus;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input() readOnly = false;
    @Input() alarmUsersList: AlarmUser[] | AlarmValidator[] = [];
    @Input() validatorMode: boolean = false;
    public subscriptions: any[] = [];
    public validators: any[] = [];
    private reloadProjectAlarmsUserRemove: Subscription;

    constructor(private stateService: StatesService,
                private toastr: ToastrService,
                private translate: TranslateService,
                private modalService: ModalService,
                public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.readOnly) {
            this.displayedColumns = !this.validatorMode ? ['email', 'firstname', 'lastname', 'subscription', 'phone'] : ['email', 'firstname', 'lastname'];
        } else {
            this.displayedColumns = !this.validatorMode ? ['email', 'firstname', 'lastname', 'phone', 'subscription', 'action'] : ['email', 'firstname', 'lastname', 'action'];
            this.reloadProjectAlarmsUserRemove = this.stateService.reloadProjectAlarmsUserRemove.subscribe(() => {
                this.initList();
            });
        }
        this.initList();
    }

    ngOnDestroy() {
        if (!this.readOnly) {
            this.reloadProjectAlarmsUserRemove.unsubscribe();
        }
    }

    openModal(): void {
        const modalRef = this.modalService.openNgbModal(ProjectAlarmsUserAddListComponent, {size: 'lg'});
        modalRef.componentInstance.alarmUsersList = this.alarmUsersList;
        modalRef.componentInstance.validatorMode = this.validatorMode;
    }

    initList(): void {
        this.alarmUsers = new MatTableDataSource(this.alarmUsersList);
        this.alarmUsers.filter = null;
        this.alarmUsers.sort = this.sort;
        this.alarmUsers.paginator = this.paginator;
        this.setSubscriptions();
        this.setValidators();
    }

    applyFilter(filterValue: string): void {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.alarmUsers.filter = filterValue;
    }

    removeUserToProject(user: any): void {
        const alarmUsersListTemp: any[] = [];
        this.alarmUsersList.forEach(u => {
            if (user.id !== u.id) {
                alarmUsersListTemp.push(u);
            }
        });
        this.alarmUsersList = alarmUsersListTemp;
        this.initList();
    }

    setSubscriptions(): void {
        this.subscriptions = [];
        this.alarmUsers.data.forEach((user: AlarmUser) => {
            this.subscriptions.push({
                user: user.id,
                send_email: user.send_email,
                send_sms: user.send_sms,
                send_voice: user.send_voice
            });
        });
    }

    setValidators(): void {
        this.validators = [];
        this.alarmUsers.data.forEach((user: AlarmValidator) => {
            this.validators.push({
                user: user.id
            });
        });
    }

}
